var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuantitySubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#270ADC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15150_60717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2908 15.8215L6.82417 12.3548C6.6159 12.1465 6.6159 11.8088 6.82417 11.6006L7.5784 10.8463C7.78667 10.638 8.12438 10.638 8.33265 10.8463L10.668 13.1816L15.6699 8.17964C15.8782 7.97137 16.2159 7.97137 16.4242 8.17964L17.1784 8.93389C17.3867 9.14216 17.3867 9.47985 17.1784 9.68814L11.0451 15.8215C10.8368 16.0298 10.4991 16.0298 10.2908 15.8215Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15150_60717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white",
    transform: "translate(6.66797 6.66699)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantitySubmit);
export default __webpack_public_path__ + "static/media/QuantitySubmit.6a456fc56c1902adf7d1b845efe213de.svg";
export { ForwardRef as ReactComponent };